import React from 'react';

export const DEFAULT_CLOSED_MESSAGE = 'Online orders are currently closed. Thank you for your support!';

// The banner shows only the first line of the message; the full text lives in the modal
export const OrdersClosedBanner = ({ message, onDetails }) => {
  const lines = (message || DEFAULT_CLOSED_MESSAGE).split('\n').map((l) => l.trim()).filter(Boolean);
  return (
    <div className="orders-closed-banner" role="status">
      <p className="orders-closed-banner-text">{lines[0]}</p>
      {lines.length > 1 && onDetails && (
        <button type="button" className="orders-closed-details" onClick={onDetails}>
          View details
        </button>
      )}
    </div>
  );
};

export const OrdersClosedModal = ({ message, onClose }) => (
  <div className="site-popup-overlay" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
    <div className="site-popup-modal orders-closed-modal" role="dialog" aria-modal="true" aria-labelledby="orders-closed-title">
      <div className="site-popup-header">
        <h3 id="orders-closed-title">Online Orders Closed</h3>
        <button type="button" className="site-popup-close" aria-label="Close" onClick={onClose}>✕</button>
      </div>
      <div className="site-popup-body">
        <p className="orders-closed-text">{message || DEFAULT_CLOSED_MESSAGE}</p>
        <button type="button" className="orders-closed-ok" onClick={onClose}>OK</button>
      </div>
    </div>
  </div>
);
